export default "//static.tradera.net/touchweb/static/output/images/googleplay.32c4c811.svg";